import { aboutPoints } from "@/mocks/maydayContent";

export default function About() {
  return (
    <section id="guanyu" className="scroll-mt-24 w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-[1200px] gap-10 px-4 md:px-6 py-12 md:py-16 lg:grid-cols-2 lg:gap-14">
        <div>
          <div className="text-xs font-medium tracking-widest text-primary-600 mb-2">ABOUT US</div>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">关于五一爆料</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们是一支关注公众假期体验与消费权益的内容团队。面对每逢长假就刷屏的调休讨论、层出不穷的出游乱象与消费套路，我们希望提供一个可信、可读、可用的信息源——把政策讲清楚、把套路拆明白、把方法给到位。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信，好的假期不该只停留在热搜里的情绪宣泄，而应建立在充分的知情与理性的选择之上。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {aboutPoints.map((p) => (
              <div key={p.title} className="rounded-lg bg-background-100/70 border border-background-200/70 p-4">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${p.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                  </span>
                  <span className="font-medium text-foreground-900">{p.title}</span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col justify-center">
          <div className="rounded-lg border border-background-200/70 bg-background-100/40 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-xl w-6 h-6 flex items-center justify-center"></i>
              </span>
              <div>
                <div className="font-heading text-2xl font-bold text-foreground-950">五一爆料</div>
                <div className="text-xs text-foreground-500">节日背后的真相 · 独立内容平台</div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700">
              我们专注于公众节假日相关议题的深度观察，为忙碌的现代人梳理每一次长假背后的安排、争议与选择。内容涵盖调休政策解读、假期历史沿革、出游避坑与消费维权等实用话题。
            </p>
            <div className="mt-6 space-y-3">
              {[
                { icon: "ri-question-answer-line", label: "常见问题", href: "#wenda", text: "高频疑问集中解答" },
                { icon: "ri-megaphone-line", label: "线索爆料", href: "#tougao", text: "分享你掌握的信息" },
                { icon: "ri-mail-open-line", label: "联系我们", href: "mailto:tips@maydayleaks.example", text: "tips@maydayleaks.example" },
              ].map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  className="flex items-center gap-3 rounded-lg bg-background-50 px-4 py-3 transition-colors hover:bg-background-100"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${l.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{l.label}</div>
                    <div className="text-xs text-foreground-500">{l.text}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}